import React from 'react'
import ShoppingBag from '../components/shoppingbag'

const Checkout = () => {
  return (
    <ShoppingBag />
  )
}

export default Checkout